// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"26":"react-datetime","53":"mockups","524":"app"}[chunkId] || chunkId) + ".chunk.js";
};